import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    title: {
      namespaced: true,
      state: {
        pageTitle: 'マイページ',
      },
      actions: {
        changePage({commit}, title) {
          commit('changeTitle', title);
        },
      },
      mutations: {
        changeTitle(state, title) {
          state.pageTitle = title;
        },
      },
      getters: {
        pageTitle(state) {
          return state.pageTitle;
        },
      },
    },
    tab: {
      namespaced: true,
      state: {
        tabName: 'dashboard',
      },
      actions: {
        changeTab({commit}, tab) {
          commit('changeTabName', tab);
        },
      },
      mutations: {
        changeTabName(state, tab) {
          state.tabName = tab;
        },
      },
      getters: {
        tabName(state) {
          return state.tabName;
        },
      },
    },
    users:{
      namespaced: true,
      state: {
        progress: 'display',
      },
      actions: {
        pushProgress({commit}, progress) {
          commit('changeProgress', progress);
        },
      },
      mutations: {
        changeProgress(state, progress) {
          state.progress = progress;
        },
      },
      getters: {
        progress(state) {
          return state.progress;
        },
      },
    },
    billingInfo:{
      namespaced: true,
      state: {
        progress: 'display',
      },
      actions: {
        pushProgress({commit}, progress) {
          commit('changeProgress', progress);
        },
      },
      mutations: {
        changeProgress(state, progress) {
          state.progress = progress;
        },
      },
      getters: {
        progress(state) {
          return state.progress;
        },
      },
    }
  }
})
